import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '../../../shared/Typography/PageTitle';
import useInvoices from '../../../../hooks/invoices/useInvoices';
import { GeneralTable } from '../../../shared/Table/GeneralTable';
import {
    InvoiceData,
    InvoiceHeadCellContent,
} from '../../../../models/Invoice';
import { INVOICE_HEAD_CELLS } from '../../../../utils/constans/tableHeads/invoicesTableHead';
import { TableLoadingLayout } from '../../../layouts/LoadingLayouts/TableLoadingLayout';
import { Box } from '@mui/material';
import { InvoicesInformation } from '../../../invoices/InvoicesInformation';
import { InvoicesTableRow } from '../../../invoices/InvoicesTableRow';
import { isNullOrUndefined } from '../../../../utils/utils';

export const Invoices = () => {
    const { t } = useTranslation('invoices', {
        keyPrefix: 'INVOICES',
    });
    const [invoiceList, setInvoiceList] = useState(null);

    const invoiceSWR = useInvoices();
    const { invoices, isLoading, isError, forceRefresh } =
        invoiceSWR.useInvoicesSWR();

    useEffect(() => {
        if (!isLoading && isNullOrUndefined(invoiceList)) {
            setInvoiceList(invoices);
        }
    }, [isLoading, invoices]);

    const tableHeadSettings = {
        translateNs: 'invoices',
        translatePrefix: 'INVOICES.TABLE_HEAD',
        selectable: false,
        headContent: INVOICE_HEAD_CELLS,
    };

    const tableToolbarSettings = {
        translateNs: 'invoices',
        translatePrefix: 'INVOICES.TABLE_TOOLBAR',
    };

    const filterTerm = (search) => {
        return invoiceList.filter((elem) => {
            return (
                elem.invoiceNumber.includes(search.toLowerCase()) ||
                elem.price_net.toString().includes(search)
            );
        });
    };

    const handleFilter = (filterType) => {
        switch (filterType) {
            case 'overDue':
                setInvoiceList(
                    invoices.filter((elem) => {
                        return (
                            elem.status.toLowerCase() != 'paid' &&
                            new Date(elem.paymentDeadline) < new Date()
                        );
                    })
                );
                break;
            case 'balance':
                setInvoiceList(
                    invoices.filter((elem) => {
                        return (
                            elem.status.toLowerCase() != 'paid'
                        );
                    })
                );
                break;
            default:
                setInvoiceList(invoices);
        }
    };

    return (
        <>
            <PageTitle>{t('PAGE_TITLE')}</PageTitle>
            <InvoicesInformation handleFilter={handleFilter} />
            {isError && <Box>{t('LOADING_ERROR')}</Box>}
            {isLoading && <TableLoadingLayout />}
            {!isLoading && invoiceList && (
                <GeneralTable<InvoiceData, InvoiceHeadCellContent>
                    fullList={invoiceList}
                    rowComponent={InvoicesTableRow}
                    filterTerm={filterTerm}
                    defaultOrderBy={'date'}
                    defaultOrder={'desc'}
                    selectHandleId={'invoiceNumber'}
                    tableHeadSettings={tableHeadSettings}
                    tableToolbarSettings={tableToolbarSettings}
                    forceRefresh={forceRefresh}
                    isLoading={isLoading}
                />
            )}
        </>
    );
};
